export const GOOGLE_APIKEY = "AIzaSyCtuqpOJyb2S-u-IeaA4Woy8slInsFhixM";
export const IS_TEST = false;
// export const SERVER_URL = "http://localhost:8000";
export const SERVER_URL = "https://api.agentmule.com";
export const API_VERSION = "/api/v1";
